/**
 * Modal that shows the "How Cello compares" table. Rendered from the FAQ
 * answer so the comparison doesn't have to jam itself into the 800px FAQ
 * column. Reuses the table markup from CompetitorCompareBass (`inline` mode).
 */
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import CompetitorCompareBass from "./CompetitorCompareBass";

interface CompetitorCompareDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

const CompetitorCompareDialog = ({ open, onOpenChange }: CompetitorCompareDialogProps) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        className="max-w-[1200px] w-[calc(100%-24px)] bg-[#FAF1E8] border-0 rounded-[14px] shadow-[0_30px_80px_rgba(36,31,16,0.35)] p-6 sm:p-10 max-h-[92vh] overflow-y-auto"
        style={{
          backgroundImage:
            "radial-gradient(rgba(64,59,29,0.13) 1.3px, transparent 1.3px)",
          backgroundSize: "64px 64px",
        }}
      >
        <DialogTitle asChild>
          <h3
            className="font-serif font-black leading-[1.05] tracking-[-0.5px] text-[#241F10]"
            style={{ fontSize: "clamp(28px, 3.6vw, 44px)" }}
          >
            How Cello compares
          </h3>
        </DialogTitle>
        <p className="mt-3 max-w-[600px] font-serif italic text-[15px] sm:text-[17px] text-[#6B6449] leading-relaxed">
          One flat fee, your whole closet, a styling team all year — here's how that stacks up.
        </p>
        <div className="mt-8">
          <CompetitorCompareBass inline />
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default CompetitorCompareDialog;
